<template>
    <div class="page-cabinet-referral-create">
        <div class="page-cabinet-referral-create__info">
            <div>
                <div class="page-cabinet-referral-create__info-title">
                    Зарабатывайте вместе с&nbsp;SimpleEstate
                </div>
                <div class="page-cabinet-referral-create__info-description">
                    Приглашайте друзей и&nbsp;получайте вознаграждение за&nbsp;их&nbsp;первую инвестицию
                </div>
            </div>
            <div class="page-cabinet-referral-create__info-illustration" />
            <div class="page-cabinet-referral-create__info-offers">
                <div class="page-cabinet-referral-create__info-offer">
                    <div class="page-cabinet-referral-create__info-offer-badge">
                        для физических лиц
                    </div>
                    <div>
                        <span class="page-cabinet-referral-create__info-offer-number _line">2</span>
                        <span class="page-cabinet-referral-create__info-offer-number">%</span>
                    </div>
                    <div class="page-cabinet-referral-create__info-offer-text">
                        Налоги мы платим за&nbsp;вас
                    </div>
                </div>
                <div class="page-cabinet-referral-create__info-offer">
                    <div class="page-cabinet-referral-create__info-offer-badge">
                        для юридических лиц
                    </div>
                    <div>
                        <span class="page-cabinet-referral-create__info-offer-number _line">3</span>
                        <span class="page-cabinet-referral-create__info-offer-number">%</span>
                    </div>
                    <div class="page-cabinet-referral-create__info-offer-text">
                        Налоги вы платите сами
                    </div>
                </div>
            </div>
            <div class="page-cabinet-referral-create__info-offers-mobile">
                <div class="page-cabinet-referral-create__info-offer">
                    <div class="page-cabinet-referral-create__info-offer-badge">
                        для физ. лиц
                    </div>
                    <div>
                        <span class="page-cabinet-referral-create__info-offer-number _line">2</span>
                        <span class="page-cabinet-referral-create__info-offer-number _line">%</span>
                    </div>
                    <div class="page-cabinet-referral-create__info-offer-text">
                        Налоги<br />мы платим за вас
                    </div>
                </div>
                <div class="page-cabinet-referral-create__info-offer">
                    <div class="page-cabinet-referral-create__info-offer-badge">
                        для юр. лиц
                    </div>
                    <div>
                        <span class="page-cabinet-referral-create__info-offer-number _line">3</span>
                        <span class="page-cabinet-referral-create__info-offer-number _line">%</span>
                    </div>
                    <div class="page-cabinet-referral-create__info-offer-text">
                        Налоги<br />вы платите сами
                    </div>
                </div>
            </div>
            <div class="page-cabinet-referral-create__info-buttons">
                <ui-button
                    v-on:click="apply"
                    v-bind:disabled="!getUserJuridicalInfoResult"
                    text="Начать"
                    size="lg"
                />
            </div>
        </div>
        <div class="page-cabinet-referral-create__illustration" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '~/config';

export default {
    name: 'page-cabinet-referral-create',
    data: () => ({
        referralLandingUrl: config.urls.referralLanding,
    }),
    computed: {
        ...mapState('referral', [
            'createReferrerResult',
        ]),
        ...mapState('users', [
            'getUserJuridicalInfoResult',
        ]),
        user() {
            return this.$store.getters['users/user'];
        },
    },
    methods: {
        apply() {
            this.$store.commit('modals/push', {
                name: 'referral-create',
            });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-referral-create {
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    border-radius: @border-radius-lg;
    padding: 76px;
    margin: 24px 0;
    overflow: hidden;

    background-color: @color-gray-lightest;
    &__info {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 64px;
        max-width: 480px;
        &-title {
            .typography-extra-large();

            margin-bottom: 16px;
        }
        &-description {
            .typography-small();
        }
        &-illustration {
            display: none;
            aspect-ratio: 16 / 11;
            width: 100%;
            background-image: url('~static/images/referral/page-cabinet-referral-create-bg.webp');
            background-size: cover;
            background-position: center top;
            background-repeat: no-repeat;
            overflow: hidden;
        }
        &-offers-mobile,
        &-offers {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
        }
        &-offers-mobile {
            display: none;
        }
        &-offer,
        &-offer-mobile {
            position: relative;
            padding: 8px 24px 16px 24px;
            border: 1px solid @color-gray-light;
            border-radius: @border-radius-xl;
            &-badge {
                .typography-caption();

                position: absolute;
                left: 16px;
                top: 0;
                transform: translateY(-50%);
                padding: 2px 8px;
                border-radius: @border-radius-sm;
                color: @color-gray-lightest;
                background-color: @color-primary;
                text-transform: uppercase;
                font-weight: bold;
            }
            &-number {
                display: inline;
                font-size: 7rem;
                font-weight: bold;
                color: @color-primary;
                &._line {
                    border-bottom: 2px solid @color-primary;
                }
            }
            &-text {
                .typography-body();

            }
        }
        &-buttons {
            &-item {
                flex: 0 0 auto;
                width: 207px;
                margin: 12px;
            }
        }
    }
    &__illustration {
        flex: 0 0 calc((100vh - 125px) * 0.6);
        max-width: 50%;

        background-image: url('~static/images/referral/page-cabinet-referral-create-bg.webp');
        background-position: center top;
        background-size: 100%;
        background-repeat: no-repeat;
    }
    @media @media-lg-down {
        &__info {
            gap: 32px;
            &-illustration {
                display: block;
            }
        }
        &__illustration {
            display: none;
        }
    }
    @media @media-lg-down {
        justify-content: center;
        padding: 32px;
        &__info {
            align-items: center;

            &-title {
                text-align: center;
            }
            &-description {
                text-align: center;
            }
        }

    }
    @media @media-sm-down {
        padding: 14px;
        &__info {
            &-title {
                .typography-large();

                margin-bottom: 6px;
            }
            &-description {
                .typography-heading();
            }
            &-offers {
                display: none;
            }
            &-offers-mobile {
                display: grid;
            }
            &-offer {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 12px;
                padding: 12px;
                padding-top: 16px;
                &-badge {
                    left: 50%;
                    transform:  translateY(-50%) translateX(-50%);
                    min-width: 110px;
                    text-align: center;
                }
                &-number {
                    .typography-extra-large();
                }
                &-text {
                    text-align: center;
                }
            }
        }
    }
}
</style>
